import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import {classNames, getFormatClassNames} from '~/src/utilities/helpers/css';
import {SectionLayout} from '~/src/utilities/constants/layout';
import {ContentStyle} from '~/src/utilities/constants/style';
import {SiteArea} from '~/src/utilities/constants/navigation';
import {ColorScheme, TeaserFormat} from '~/src/utilities/constants/formats';
import {withSectionContext} from '~/src/components/context/SectionContext';
import {withSettingsContext} from '~/src/components/context/SettingsContext';
import {TeaserTypes} from '~/src/utilities/constants/types';
import initPolyglot from '~/src/utilities/libs/polyglot';
import NavLifestyle from '~/src/components/svg/navigation/NavLifestyle';
import NavVideo from '~/src/components/svg/navigation/NavVideo';

import css from './TeaserContentHeader.module.scss';
import i18n from './TeaserContentHeader.i18n.json';

const getTranslation = initPolyglot(i18n);

const TeaserContentHeader = (props) => {
    const isBreakingNews = props.isBreakingNews;
    const siteArea = get(props, 'context.settings.siteArea', SiteArea.NEWS);
    const layout = get(props, 'context.section.layout');
    const isFridaySection = siteArea === SiteArea.NEWS && (layout === SectionLayout.FRIDAY || props.styleName === ContentStyle.FRIDAY);
    const isLematinSection = siteArea === SiteArea.NEWS && (layout === SectionLayout.LEMATIN || props.styleName === ContentStyle.LEMATIN);
    const isLifestyleSection = siteArea === SiteArea.NEWS && (layout === SectionLayout.LIFESTYLE || props.styleName === ContentStyle.LIFESTYLE);
    const isCarouselSection = layout === SectionLayout.CAROUSEL || layout === SectionLayout.CAROUSEL_VIDEO_SERIES;
    const isVideoCarousel = siteArea === SiteArea.NEWS && layout === SectionLayout.CAROUSEL && props.type === TeaserTypes.VIDEOS;

    const className = classNames(css, 'teaserContentHeader', getFormatClassNames(props.format), props.type, siteArea, {
        isFridaySection,
        isLematinSection,
        isLifestyleSection,
        isCarouselSection,
        isBreakingNews
    });

    return (
        <header className={className}>
            {props.showTitleHeader && !isLifestyleSection && (
                <h2 className={css.titleHeader}>
                    {isVideoCarousel && (
                        <span className={css.titleHeaderIcon}>
                            <NavVideo />
                        </span>
                    )}
                    {props.titleHeader}
                </h2>
            )}
            {isLifestyleSection && (
                <h2 className={css.titleHeader}>
                    <NavLifestyle />
                    {getTranslation('lifestyleTitleHeader')}
                </h2>
            )}
            <h1 className={css.title}>
                {props.showOrdinal && <span className={css.ordinal}>{props.sortID + 1}</span>}
                {props.title}
            </h1>
            {props.showLead && <p className={css.lead}>{props.lead}</p>}
        </header>
    );
};

if (process.env.NODE_ENV === 'development') {
    TeaserContentHeader.propTypes = {
        showTitleHeader: PropTypes.bool,
        titleHeader: PropTypes.string,
        title: PropTypes.string,
        showLead: PropTypes.bool,
        showOrdinal: PropTypes.bool,
        lead: PropTypes.string,
        isBreakingNews: PropTypes.bool,
        styleName: PropTypes.string,
        sortID: PropTypes.number,
        format: PropTypes.shape({
            primaryGrid: PropTypes.oneOf(Object.values(TeaserFormat)).isRequired,
            secondaryGrid: PropTypes.oneOf(Object.values(TeaserFormat)).isRequired,
            colorScheme: PropTypes.oneOf(Object.values(ColorScheme)).isRequired
        })
    };
}

export default withSettingsContext(withSectionContext(TeaserContentHeader));
